import { CampaignType } from '@/constants/postType.constants';
import { getUserCountry } from '@/utils/user.helper';

export const TEMPLATES = [
  {
    createdAt: '2022-08-01T04:10:33.989Z',
    created_by: 1,
    description: 'Create a Fundraising Project',
    default_message: `Create a ready-to-use template for your supporters to launch a giving campaign.`,
    id: 1,
    name: 'Create a Fundraising Project',
    post_bg_resource_type: 'image',
    post_bg_resource_url: '/assets/images/celebrate-2.png',
    updatedAt: '2022-08-01T04:10:33.989Z',
    // appName: AppPreferenceItem.FundRaise,
  },
  {
    createdAt: '2022-08-01T04:10:33.989Z',
    created_by: 1,
    description: 'Create an In-Kind Project',
    default_message: `Create a ready-to-use template for your supporters to launch an in-kind campaign.`,
    id: 2,
    name: 'Create an In-Kind Project',
    post_bg_resource_type: 'image',
    post_bg_resource_url: '/assets/images/celebrate-1.png',
    updatedAt: '2022-08-01T04:10:33.989Z',
    // appName: AppPreferenceItem.InKindDonation,
  },
];

export const PROJECTS = [
  {
    id: 1,
    type: CampaignType.FundRaise,
  },
  {
    id: 2,
    type: CampaignType.CollectGoods,
  },
];

export function getProjectTemplates(user) {
  const userCountry = getUserCountry(user);
  const processedTemplates = TEMPLATES.map((template) => {
    const updatedTemplate = { ...template };

    if (userCountry === 'IN') {
      updatedTemplate.default_message = updatedTemplate.default_message.replace(
        /Nonprofit/g,
        'NGO',
      );
      updatedTemplate.description = updatedTemplate.description.replace(
        /Nonprofit/g,
        'NGO',
      );
      updatedTemplate.name = updatedTemplate.name.replace(/Nonprofit/g, 'NGO');
    }

    // if (user?.activeCommunity?.orgType === OrgType.NonProfit) {
    //   updatedTemplate.default_message = updatedTemplate.default_message.replace(
    //     / a /g,
    //     ' your ',
    //   );
    //   updatedTemplate.description = updatedTemplate.description.replace(
    //     / a /g,
    //     ' your ',
    //   );
    //   updatedTemplate.name = updatedTemplate.name.replace(/ a /g, ' your ');
    // }

    return updatedTemplate;
  });

  // return processedTemplates.filter((template) =>
  //   hasAppAccess(template.appName),
  // );
  return processedTemplates;
}
